import { MDBIcon } from 'mdbreact'
import React from 'react'
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import PeticionTraeDatos from '../../../hooks/useTraeDatos';
import Productos from './Tienda/Productos';

const ruta = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API

const Tienda = () => {
    const [categorias] = PeticionTraeDatos(ruta + 'categorias/')
    const [productos] = PeticionTraeDatos(ruta + 'productos/')

    return (
        <div className='tienda row'>
            <div className='tienda_menu col-md'>
                <div className='tienda_buscar'>
                    <h5>BUSCAR</h5>
                    <div className="input-group form-sm form-1 pl-0">
                        <input
                            className="form-control my-0 py-1"
                            type="text"
                            placeholder="Buscar Producto"
                            aria-label="Buscar"
                        />
                        <div className="input-group-prepend">
                            <span className="input-group-text black lighten-3" id="basic-text1">
                                <MDBIcon className="text-white" icon="search" />
                            </span>
                        </div>
                    </div>
                </div>
                <div className='tienda_categorias'>
                    <h5>CATEGORÍAS</h5>
                    <div className='tienda-categorias_lista'>
                        <ul className='tienda-categorias_lista_items'>
                            {categorias && categorias.map(categoria => (
                                <li key={categoria.id}>{categoria.nombre}</li>
                            ))}
                            <li className='tienda-categorias-bold'>Ver más...</li>
                        </ul>
                        <ul>
                            <li className='tienda-categorias-bold'>Ver más...</li>
                        </ul>
                    </div>
                </div>
                <hr />
                <div className='tienda_filtro'>
                    <h5>FILTRAR POR PRECIO</h5>
                    <RangeSlider
                        id="range-slider"
                        defaultValue={[0, 50]}
                        rangeSlideDisabled={true} />
                    <p>Precio $25.000 - $30.000</p>
                </div>
            </div>
            <div className='tienda-productos col-md-9'>
                <Productos productos={productos} ruta={ruta} />
            </div>
        </div>
    )
}

export default Tienda